export default function safeParse<T>(json: string | undefined, fallbackValue: T): T
export default function safeParse<T>(json: string | undefined, fallbackValue?: T): T | undefined {
  try {
    if (json) {
      return JSON.parse(json) as T
    } else {
      return fallbackValue
    }
  } catch (error) {
    return fallbackValue
  }
}
